import { services } from "../../../../../../engines/gameEngine";
import { PLATFORM_CODE } from "../../../../../../engines/services/ossService";


export const getKaoguMountainConfig: { [id: number]: KaoguMountainInfo } = {
    0: {
        id: 0,
        nickName: "扛狼洞",
        buyPrice: 2000000,// 200万

        outsideIDList:  [ 1,  3,  11,  17,  19],
        outsideProList: [20, 20,  20,  20,  20],
        outsideNumList: [0, 1, 2, 3],
        outsideNumProList: [50, 30, 15, 5],

        insideIDList: [0, 2, 4, 5, 6, 7, 8, 9],
        insideProList:services().ossSrv.getPlatform() == PLATFORM_CODE.H5? [10, 40, 10, 10, 10, 10, 40, 10, 10]:[5, 20, 10, 10, 10, 5, 20, 20],//H5
        insideNumList: [2, 3, 4],
        insideNumProList: [50, 50, 50],
        tips: "听别人说这里出过恐龙，又听别人说这里出过狼，又听说这里还有恐龙跟狼打架，恐龙赢了扛着狼走"
    },
    1: {
        id: 1,
        nickName: "盘丝袜洞",
        buyPrice: 5000000,// 500万

        outsideIDList:  [ 1,  3,  11,  17,  19],
        outsideProList: [20, 20,  20,  20,  20],
        outsideNumList: [0, 1, 2, 3],
        outsideNumProList: [50, 30, 15, 5],

        insideIDList: [0,  7,  8,  9,  10,  11,  12,  13,  14,  18],
        insideProList: services().ossSrv.getPlatform() == PLATFORM_CODE.H5? [10, 50, 10, 10, 10, 10, 10, 10, 30]:[5, 15, 15, 15, 15, 10, 10, 10, 5],// H5
        insideNumList: [1, 2, 3],
        insideNumProList: [50, 50, 50],
        tips: "好好的一个洞名，非要加个袜字，纯纯的搞心态"
    },
    2: {
        id: 2,
        nickName: "山水帘洞",
        buyPrice: 10000000,// 1000万

        outsideIDList:  [ 1,  3,  11,  17,  19],
        outsideProList: [20, 20,  20,  20,  20],
        outsideNumList: [0, 1, 2, 3],
        outsideNumProList: [50, 30, 15, 5],

        insideIDList: [0, 15, 16, 18, 20, 21, 22, 23, 24],
        // insideProList: [10, 30, 25, 15, 10, 4, 3, 2, 1],
        insideProList:services().ossSrv.getPlatform() == PLATFORM_CODE.H5? [5, 10, 10, 50, 10, 10, 30, 30]:[5, 10, 10, 10, 10, 15, 20, 20],//h5
        insideNumList: [1, 2, 3],
        insideNumProList: [50, 50, 50],
        tips: "这难道是那个猴的洞府"
    }
}

export function isMine(id:number)
{
    const mine:number[]=[4,5,6,12,13,15,16,20,21,22];//矿物
    return mine.includes(id);
}


export const getKaoguItemConfig: { [id: number]: KaoguItemInfo } = {
    0: {
        id: 0,
        nickName: "",
        sellPrice: 0,
        tips: "这是一块空泥巴,你什么都没有获得",
        spriteimg:"",
        // itemPerfab:['kaoguArticleItemBase']
    },
    1: {
        id: 1,
        nickName: "尿壶",
        sellPrice: 100000,//10万
        tips: "一千年前的人使用的尿壶，价值极高",
        spriteimg:"kaoguitem1",
        itemPerfab:['kaoguArticleItemNiaohu','kaoguArticleItemNiaohu1','kaoguArticleItemNiaohu2'],
        randomAngle:true
    },
    2: {
        id: 2,
        nickName: "前朝古画",
        sellPrice: 5000000,
        tips: "一幅山水古画画得甚是佳作，可惜没有落款，不敢估太高价值",
        spriteimg:"spr_jiaChuanGuHui",
        itemPerfab:['kaoguArticleItemHua','kaoguArticleItemHua1','kaoguArticleItemHua2'],
    },
    3: {
        id: 3,
        nickName: "陶瓷水杯",
        sellPrice: 50000,//5万
        tips: "不知名的破水杯，此时不卖更待何时。",
        spriteimg:"kaoguitem3",
        itemPerfab:['kaoguArticleItembeizi','kaoguArticleItembeizi1','kaoguArticleItembeizi2'],
        randomAngle:true
        
    },
    4: {
        id: 4,
        nickName: "胆结石",
        sellPrice: 800000,//80万
        tips: "澳特漫上次手术后，遗失的胆结石！",
        spriteimg:"kaoguitem4",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    5: {
        id: 5,
        nickName: "肾结石",
        sellPrice:100000,//10万
        tips: "不知名的世外高僧遗留的肾结石！",
        spriteimg:"kaoguitem5",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    6: {
        id: 6,
        nickName: "紫金矿石",
        sellPrice: 500000,//50万
        tips: "矿洞内最常见的矿石。",
        spriteimg:"kaoguitem6",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    7: {
        id: 7,
        nickName: "士卒甲",//
        sellPrice: 1 * Math.pow(10, 7),//1千万
        itemID: 50030,
        tips: "大丈夫身先士卒，铸造自神秘金属，并蕴含着战神之力，实而不华",
        spriteimg:"spr_shizujia_50030",
        itemPerfab:['kaoguArticleItemJia','kaoguArticleItemJia1','kaoguArticleItemJia2']
    },
    8: {
        id: 8,
        nickName: "兵马俑（手持AK）",//
        sellPrice: 2000000,//200万
        tips: "兵马俑？AK？？发了发了，这珍藏起来不得了。",
        spriteimg:"kaoguitem8",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    9: {
        id: 9,
        nickName: "鸟国玉玺",
        sellPrice: 1000000,//100万
        tips: "鸟国是哪国？赶紧出手，别砸在手里了",
        spriteimg:"spr_chuangGuoYuXi_ci",
        itemPerfab:['kaoguArticleItemYuXiCi','kaoguArticleItemYuXiCi1','kaoguArticleItemYuXiCi2'],
        randomAngle:true
    },
    10: {
        id: 10,
        nickName: "马踏飞鸡",
        sellPrice: 1000000,//100万
        tips: "马踏飞燕的弟弟马踏飞鸡，绝世珍宝值得收藏！",
        spriteimg:"kaoguitem7",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan'],
        randomAngle:true
    },
    11: {
        id: 11,
        nickName: "澳特漫",
        sellPrice: 8 * Math.pow(10, 3),//8000
        tips: "现代假玉澳特漫一只，卖了吧！送人也没人要。",
        spriteimg:"kaoguitem11",
        itemPerfab:['kaoguArticleItemAtm','kaoguArticleItemAtm1','kaoguArticleItemAtm2'],
        randomAngle:true
    },
    12: {
        id: 12,
        nickName: "黑金矿石",
        sellPrice: Math.pow(10, 6),//100万
        tips: "为数不多的稀有矿石。",
        spriteimg:"kaoguitem12",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    13: {
        id: 13,
        nickName: "舍利子",
        sellPrice: 3 * Math.pow(10, 7),//3000万
        tips: "某寺高僧修炼百年后化成的舍利子。",
        spriteimg:"kaoguitem13",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    14: {
        id: 14,
        nickName: "极品马桶",//
        sellPrice: 10000000,//1000万
        tips: "据砖家鉴定这是五百年前孙猴子使用的马桶。",
        spriteimg:"kaoguitem14",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    15: {
        id: 15,
        nickName: "黄金胆结石",//
        sellPrice: 1000000,//100万
        tips: "金色传说！稀有的黄金胆结石，展览效果直接拉满。",
        spriteimg:"kaoguitem15",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    16: {
        id: 16,///
        nickName: "黄金肾结石",//
        sellPrice: 5000000,//500万
        tips: "古时候某位诗人割下结石，经过几百年发酵成了黄金肾结石。",
        spriteimg:"kaoguitem16",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    17: {
        id: 17,
        nickName: "痰盂",
        sellPrice: 2000,//2000
        tips: "宋朝痰盂，不确定是不是富家千金的。",
        spriteimg:"kaoguitem17",
        itemPerfab:['kaoguArticleItemTanyu','kaoguArticleItemTanyu1','kaoguArticleItemTanyu2'],
        randomAngle:true
    },
    18: {
        id: 18,
        nickName: "工匠之锤",
        sellPrice: 80000000,//8000万
        itemID: 50031,
        tips: "一把特殊的打造工具，拥有神奇的打造能力，可以将普通的金属加工成稀世珍宝或是强力武器",
        spriteimg:"spr_gongjianzhichui_50031",
        itemPerfab:['kaoguArticleItemChuai','kaoguArticleItemChuai1','kaoguArticleItemChuai2'],
        randomAngle:true
    },
    19: {
        id: 19,
        nickName: "青花瓷碟",
        sellPrice: 2 * Math.pow(10, 6),//200万
        tips: "做工精细，未知朝代的瓷碟，其价值抬到它不该有的位置",
        spriteimg:"kaoguitem19",
        itemPerfab:['kaoguArticleItemdiezi','kaoguArticleItemdiezi1','kaoguArticleItemdiezi2'],
        randomAngle:true
    },
    20: {
        id: 20,
        nickName: "彩色矿石",
        sellPrice: Math.pow(10, 7),//1000万
        tips: "七彩矿石，乃是补天时候剩余的。",
        spriteimg:"kaoguitem20",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    21: {
        id: 21,
        nickName: "翡翠胆结石",//
        sellPrice: 4 * Math.pow(10, 6),//400万
        tips: "碧绿碧绿的翡翠，来自两亿年前猿人身上的。",
        spriteimg:"kaoguitem21",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    22: {
        id: 22,
        nickName: "翡翠肾结石",//
        sellPrice: 6 * Math.pow(10, 6),//600万
        tips: "碧绿的肾结石，可是这形状有点.....",
        spriteimg:"kaoguitem22",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    23: {
        id: 23,
        nickName: "定海神针",//
        sellPrice: 8 * Math.pow(10, 6),//800万
        tips: "五百年前大闹天宫的猴子，不慎将兵器遗失在此。",
        spriteimg:"kaoguitem23",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
    24: {
        id: 24,
        nickName: "紧箍咒",//
        sellPrice: 9 * Math.pow(10, 6),//900万
        tips: "猴子在五指山下被压麻了，随手将紧箍咒丢了。",
        spriteimg:"kaoguitem24",
        itemPerfab:['kaoguArticleItemBase','kaoguArticleItemSanJiao','kaoguArticleItemYuan']
    },
}
export interface KaoguItemInfo {
    /**id */
    id: number,
    /**名称 */
    nickName: string,
    /**出售价格 */
    sellPrice: number,
    /**图片名称 */
    spriteimg:string

    /**对应物品ID */
    itemID?: number
    /**描述 */
    tips: string

    /**物品prefab名称 */
    itemPerfab?:string[],
    /*是否需要随机角度*/
    randomAngle?:boolean
}
export interface KaoguMountainInfo {
    /**id */
    id: number,
    /**名称 */
    nickName: string,
    /**购买价格 */
    buyPrice: number,
    /**描述 */
    tips: string


    /**地面出现物品ID */
    outsideIDList: number[],
    /**地面物品出现概率 */
    outsideProList: number[],
    /**地面物品出现数量 */
    outsideNumList: number[],
    /**地面物品出现数量概率 */
    outsideNumProList: number[],


    /**泥土出现物品ID */
    insideIDList: number[],
    /**泥土物品出现概率 */
    insideProList: number[],
    /**泥土物品出现数量 */
    insideNumList: number[],
    /**泥土物品出现数量概率 */
    insideNumProList: number[],

}